import armsRum from '@arms/rum-browser';

type ArmsEnv = 'prod' | 'gray' | 'pre' | 'daily' | 'local';

import { getEnvironment } from '@/utils/environment';

const armsEnvMap: Record<string, ArmsEnv> = {
  local: 'local',
  development: 'local',
  testing: 'daily',
  testing7: 'daily',
  production: 'prod',
};

const getArmsEnv = (): ArmsEnv => armsEnvMap[getEnvironment()] ?? 'prod';

armsRum.init({
  endpoint:
    'https://proj-xtrace-a396f26b2598d0815d188971c02da759-cn-hangzhou.cn-hangzhou.log.aliyuncs.com/rum/web/v2?workspace=default-cms-1868493608389321-cn-hangzhou&service_id=iebq43cy4p@a8263190010c2970fe454',
  env: getArmsEnv(),
  spaMode: 'history',
  sessionConfig: {
    sampleRate: 0.1, // 采样率10%
  },
  collectors: {
    perf: true,
    webVitals: true,
    api: true,
    staticResource: true,
    jsError: true,
    consoleError: true,
    action: true,
  },
  tracing: false,
});

export default armsRum;
